import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Spinner from 'web/components/Spinner';
import Layout from 'web/components/Layout';
import OrderTabs from './OrderTabFile/OrderTabs'
import { Container } from './orderStyled'
import { Helmet } from "react-helmet";

const MyPickupOrder = () => {
    const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (<>
        <Helmet title="My Pickup Orders: Track and Manage Your Pickup Orders | PalletTrader" >
            <meta name="description"
                content="Manage pallet sales and procurement transactions seamlessly. Pallet buyers and sellers have complete shipment visibility." />
            <meta name="robots" content="index,follow" />
            <link rel="canonical" href="https://www.pallettrader.com/my-pickup-orders" />
        </Helmet>
        <Layout pageType="orderPage" topBarViewMobile={'hide'}>
            {loaderVisible && <Spinner />}
            <Container>
                <OrderTabs />
            </Container>
        </Layout>
    </>)
};

export default MyPickupOrder;